import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scaleItems", "rowTemplate"]
  static values = { approach: String }

  addRow() {
    const tbody = this.scaleItemsTarget
    const rows = tbody.querySelectorAll("tr[data-grading-system-target='scaleRow']")
    const lastRow = rows[rows.length - 1]

    // Get last max value to set as new min
    let newMin = 0
    if (lastRow) {
      const maxInput = lastRow.querySelector("input[name*='[max]']")
      if (maxInput && maxInput.value) {
        newMin = (parseFloat(maxInput.value) + 0.01).toFixed(2)
      }
    }

    // GO4S Design System : la ligne clonée reflète le markup statique des partials de barème
    const newRow = document.createElement("tr")
    newRow.setAttribute("style", "border-bottom:1px solid var(--ds-border);")
    newRow.setAttribute("data-grading-system-target", "scaleRow")

    // Show description cell if approach is objective_based OR if description column is visible in the table
    const thead = this.scaleItemsTarget.closest("table")?.querySelector("thead")
    const hasDescriptionColumn = thead ? thead.querySelectorAll("th").length >= 7 : false
    const isObjective = this.approachValue === "objective_based" || hasDescriptionColumn
    const descriptionCell = isObjective
      ? `<td style="padding:10px 14px;">
           <input type="text" name="appreciation_scale[scale_items][][description]" value=""
                  class="w-full min-w-[160px] rounded-sm border-gray-200 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
         </td>`
      : ""

    newRow.innerHTML = `
      <td style="padding:10px 14px;">
        <input type="number" name="appreciation_scale[scale_items][][min]" value="${newMin}"
               min="0" max="20" step="0.01"
               class="w-24 rounded-sm border-gray-200 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
      </td>
      <td style="padding:10px 14px;">
        <input type="number" name="appreciation_scale[scale_items][][max]" value="20"
               min="0" max="20" step="0.01"
               class="w-24 rounded-sm border-gray-200 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
      </td>
      <td style="padding:10px 14px;">
        <input type="text" name="appreciation_scale[scale_items][][code]" value=""
               maxlength="10"
               class="w-16 rounded-sm border-gray-200 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm uppercase">
      </td>
      <td style="padding:10px 14px;">
        <input type="text" name="appreciation_scale[scale_items][][label]" value=""
               class="w-full min-w-[140px] rounded-sm border-gray-200 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
      </td>
      ${descriptionCell}
      <td style="padding:10px 14px;">
        <div class="flex items-center gap-2">
          <input type="color" name="appreciation_scale[scale_items][][color]" value="#3B82F6"
                 autocomplete="off" class="color-picker-full">
        </div>
      </td>
      <td style="padding:10px 8px;">
        <button type="button" data-action="grading-system#removeRow"
                class="ds-iconbtn ds-iconbtn--danger ds-iconbtn--sm" title="${this.element.dataset.removeLabel || 'Remove'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
        </button>
      </td>
    `

    tbody.appendChild(newRow)
  }

  removeRow(event) {
    const row = event.target.closest("tr[data-grading-system-target='scaleRow']")
    const tbody = this.scaleItemsTarget
    const rows = tbody.querySelectorAll("tr[data-grading-system-target='scaleRow']")

    // Don't allow removing if only 1 row left
    if (rows.length <= 1) return

    row.remove()
  }
}
